// extracted by mini-css-extract-plugin
export default {"content-container":"BeforeYouStart_content-container__CZHwM","continue-button":"BeforeYouStart_continue-button__Jc2Et","back-link":"BeforeYouStart_back-link__bSYtY"};